import { cva, type VariantProps } from 'class-variance-authority'

import Text from 'components/ui/text'
import { cn } from 'utils/classMerge'
import { translate } from 'utils/translation'

const badgeVariants = cva('tw-px-2 tw-py-0.5 tw-text-xs  ', {
  variants: {
    variant: {
      default: 'tw-rounded-full tw-bg-zinc-100 tw-uppercase tw-text-zinc-900',
      white100: 'tw-rounded-full tw-bg-white tw-uppercase tw-text-zinc-900',
      orange50:
        'tw-rounded-full tw-bg-orange-50 tw-uppercase tw-text-orange-600',
      blue50: 'tw-rounded-full tw-bg-blue-50 tw-uppercase tw-text-blue-600',
      orange500: 'tw-rounded-full tw-bg-orange-500 tw-uppercase tw-text-white',
      blue500: 'tw-rounded-full tw-bg-blue-500 tw-uppercase tw-text-white',
      emerald50:
        'tw-rounded-md tw-border tw-border-solid tw-border-emerald-200 tw-bg-emerald-50 tw-font-medium tw-text-emerald-700',
      amber50:
        'tw-rounded-md tw-border tw-border-solid tw-border-amber-200 tw-bg-amber-50 tw-font-medium tw-text-amber-700',
      rose50:
        'tw-rounded-md tw-border tw-border-solid tw-border-rose-200 tw-bg-rose-50 tw-font-medium tw-text-rose-700',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

interface BadgeProps extends VariantProps<typeof badgeVariants> {
  /** The value to be displayed inside the badge, usually a text label */
  value: string
  /** Optional test ID for the badge element, useful for testing purposes */
  testId?: string
  /** The HTML element to render the badge as, defaults to 'span' */
  as?: 'span' | 'div'
}

const Badge = ({
  value,
  variant,
  as = 'span',
  testId = 'badge',
}: BadgeProps) => {
  if (!value) return null
  return (
    <Text
      as={as}
      data-testid={testId}
      className={cn(
        badgeVariants({
          variant,
        }),
      )}
      renderChildren
    >
      {translate(value)}
    </Text>
  )
}

export { Badge, badgeVariants }
export type { BadgeProps }
